const container = "_35scfj9n17";
const shouldHaveGroup = "_35ss1wzshvv";
const stateBox = "_35ss1npeilr";
const fraction = "_35sf13p8jk0";
const readonlyFractionValue = "_35sr1mhhr80";

export { container, fraction, readonlyFractionValue, shouldHaveGroup, stateBox };
import "./input.fraction.style.linaria.module.css";
//# sourceMappingURL=input.fraction.style.js.map
